import React from 'react';
import css from "./NoIntakeSurvey.scss";
import { getWord } from "utils/tenant";

const NoIntakeSurvey = () => {
    return (
        <div className={css['container']}>
            <img
                src="../images/starfish/thumbsup.png"
                aria-hidden="true"
                className={css['image']}
            />
            <div className={css['text']}>
                <h1 tabIndex={0}>{`You have no ${getWord('intake') || 'intake'} survey to complete at this time`}</h1>
            </div>
        </div>
    )
}

export default NoIntakeSurvey
